import { LogoAmaru } from '@components/logo';
import { useSidebarItemGroups } from '@features/dashboardLayout/hooks/useSidebarItemGroups';
import { Box, ButtonBase, Divider, Tooltip, Typography } from '@mui/material';
import { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';

interface Props {
  collapsed: boolean;
}

export const SidebarContent: FC<Props> = ({ collapsed }) => {
  const groups = useSidebarItemGroups();

  return (
    <Box px={collapsed ? 0.5 : 2} py={3}>
      <ButtonBase
        LinkComponent={(props) => <RouterLink {...props} to="/" />}
        sx={{
          width: '100%',
          cursor: 'pointer',
          textAlign: 'center',
          height: 64,
          padding: '10px 0 8px 0',
          display: { lg: 'none' },
          mb: 4,
        }}
      >
        <LogoAmaru />
      </ButtonBase>
      {groups.map((group, index, { length }) => {
        return (
          <Box key={group.title} mb={index < length - 1 ? 4 : 0}>
            <Box height={24}>
              {collapsed ? (
                index !== 0 && <Divider />
              ) : (
                <Typography fontSize="small" fontWeight="bold" textTransform="uppercase">
                  {group.title}
                </Typography>
              )}
            </Box>
            <Box py={1} display="grid" gap={0.5} justifyItems="start">
              {group.items.map((item) => {
                return (
                  <Tooltip title={collapsed ? item.title : null} placement="right">
                    <span>
                      <ButtonBase
                        key={item.title}
                        href={item.path}
                        LinkComponent={(props) => <RouterLink {...props} to={item.path} />}
                        sx={{
                          color: item.active ? 'primary.main' : 'text.secondary',
                          ':hover': {
                            bgcolor: '#ffffff12',
                          },
                          display: 'flex',
                          justifyContent: collapsed ? 'center' : 'initial',
                          overflow: 'hidden',
                          borderRadius: 1,
                          px: 2,
                          py: 1.5,
                          gap: 2,
                          alignItems: 'center',
                          width: collapsed ? 52 : 220,
                          textAlign: 'left',
                        }}
                      >
                        <item.icon fontSize="small" />
                        <Typography
                          variant="h6"
                          display={collapsed ? 'none' : 'block'}
                          sx={{
                            fontSize: 'small',
                            '@media (min-width: 600px)': {
                              fontSize: 'small',
                            },
                          }}
                          fontWeight="bold"
                        >
                          {item.title}
                        </Typography>
                      </ButtonBase>
                    </span>
                  </Tooltip>
                );
              })}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};
